// extracted by mini-css-extract-plugin
export default {"root":"PlayerPage_root__RN697","loadingScreen":"PlayerPage_loadingScreen__KNPw2"};